import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ServerTokenService } from '../../services/server-token.service';
import { LastTimeServerType, NaviLastListType } from '../../shared-modules/models/last-list';
import { LastUpdate } from '../types';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { PccDashboardComponent } from '../pcc-dashboard/pcc-dashboard.component';
import { ClientSettingsService } from '../../manageb/client-settings.service';

@Component({
  selector: 'ngx-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy, AfterViewInit {

  showAlert
  serverDashboard: LastUpdate; 
  intervalId

  @ViewChild('alarm', { static: true }) alarm: ElementRef<HTMLAudioElement>;
  
  @ViewChild('pcc', { static: true }) pcc: PccDashboardComponent;

  // Legacy nav renders <admin-nav> in admin.component, so only the redesign needs it here.
  // Read from ClientSettingsService, not NavStateService — that would close an ES-module
  // cycle through admin-routes.config, which imports this component.
  readonly navEnabled: boolean;

  constructor(
    private service: ServerTokenService,
    private afMessaging: AngularFireMessaging,
    clientSettings: ClientSettingsService,
  ) {
    this.navEnabled = !!clientSettings.settings.uiSettings.newNavigation;
    this.afMessaging.requestToken.subscribe(
      (token) => {
        console.log('Token received:', token);
        // Save this token to your backend for targeting notifications
      },
      (error) => {
        console.error('Permission denied:', error);
      }
    );

    this.afMessaging.messages.subscribe((message) => {
      console.log('New message received:', message);
    });

  }
  ngAfterViewInit(): void {
  }
  ngOnDestroy(): void {
    clearInterval(this.intervalId)
  }
  
  naviList: NaviLastListType[]
  serverList: LastTimeServerType[]

  getDashboard() {
    this.service.postWithToken('snfs/admin/getSnfDashboard', {}).subscribe((data:any) => {
      console.log(data);
      this.serverDashboard = data;
      console.log('update pcc', data.lastPCCPush);
      if(this.pcc && data.lastPCCPush?.length) {
        this.pcc.updateList(data.lastPCCPush);
      }
      const needToPlaySound = !this.showAlert;
      this.showAlert = false;
      
      
      Object.values(this.serverDashboard.serviceLastTimeSuccess).forEach(item => {
        if(this.isTimeError(item)){
          if(needToPlaySound) {
            // this.playSound().then();
          //   console.log(this.alarm.nativeElement)
          //   this.alarm.nativeElement.play()
          }
          this.showAlert = true;
        }
      })
    });
  }
  isTimeError(item) {
    const time = new Date(item.lastTime).getTime();
    const timeForAlert = item.timeForAlert;
    return Date.now() - time >= timeForAlert;
  }

  ngOnInit(): void {
    // this.getDashboard();
    // this.intervalId = setInterval(this.getDashboard.bind(this), 20 * 1000);
      // this.service.postWithToken('snfs/services/getLastList', {}).subscribe((data:any) => {
      //   console.log(data);
      //   this.naviList = data.obj.list;
      //   this.serverList = data.a;
      // });
  }

  wait = async (time) => {return new Promise(res => {setTimeout(res, time)})};
  
  async playSound() {
    console.log('playsound')
    var mp3_url = 'https://media.geeksforgeeks.org/wp-content/uploads/20190531135120/beep.mp3';
    for (let index = 0; index < 10; index++) {
      console.log('playsound ' + index);
      (new Audio(mp3_url)).play()
      await this.wait(1000);
    }
  }

  getServerLastTime(ReferralID: string) {
    return (this.serverList.find(item => item.ReferralID == ReferralID))?.lastTimeUpdate || ''
  }

  initArray() {

    const b = this.naviList.map(item => {
      return {
        ReferralID: item.ReferralID,
        PatientName: item.PatientName,
        lastUpdateTime: item.srcObject.lastTimeObject.lastUpdateTime,
        serverLastUpdateTime: this.getServerLastTime(item.ReferralID),
        status: '',
      }
    })
    b.forEach(item => {
      if(item.serverLastUpdateTime) {
        const last = new Date(item.lastUpdateTime);
        const serverLast = new Date(item.serverLastUpdateTime);
        if(last < serverLast) {
          item.status = 'BUG';
        } else if(last > serverLast) {
          item.status = 'Late';
        } else {
          item.status = 'On time';
        }
      } else {
        item.status = '';
      }
    })
    return b;
  }

}

